import _toConsumableArray from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/tmp/jenkins/workspace/ner_UI_feature_realttimeMetadata/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, createContext, useState, useEffect, useMemo, useCallback } from 'react';
var RouterContext = createContext({
  basePath: '',
  path: null
});

function useRouter() {
  return useContext(RouterContext);
}

var ssrPath = '/';
var isNode = true; // eslint-disable-line import/no-mutable-exports

try {
  isNode = window === undefined;
} catch (e) {} // eslint-disable-line no-empty


function getSsrPath() {
  return ssrPath;
}

function usePath(basePath) {
  var context = useRouter();

  var _useState = useState(context.path || getCurrentPath(basePath)),
      _useState2 = _slicedToArray(_useState, 2),
      path = _useState2[0],
      setPath = _useState2[1];

  usePopState(basePath, isNode || context.path, setPath);
  return context.path || path;
}

function getCurrentPath() {
  var basePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isNode ? getSsrPath() : window.location.pathname.replace(basePathMatcher(basePath), '') || '/';
}

function usePopState(basePath, predicate, setFn) {
  useEffect(function () {
    if (predicate) return;

    var onPopState = function onPopState() {
      setFn(getCurrentPath(basePath));
    };

    window.addEventListener('popstate', onPopState);
    return function () {
      return window.removeEventListener('popstate', onPopState);
    };
  }, [basePath]);
}

function basePathMatcher(basePath) {
  return new RegExp('^' + basePath);
}

function useRoutes(routes) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // path is the browser url location
  var path = getCurrentPath(basePath);

  var _useState3 = useState({
    path: path
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      context = _useState4[0],
      setContext = _useState4[1]; // Watch for location changes


  usePopState(basePath, isNode, function (path) {
    return setContext(function (context) {
      return _objectSpread(_objectSpread({}, context), {}, {
        path: path
      });
    });
  });
  var route = matchRoute(routes, path);
  if (!route) return null;
  return React.createElement(RouterContext.Provider, {
    value: _objectSpread(_objectSpread({}, context), {}, {
      basePath: basePath
    })
  }, route);
}

function matchRoute(routes, path) {
  var routePaths = Object.keys(routes);
  var routeMatchers = useMemo(function () {
    return routePaths.map(createRouteMatcher);
  }, routePaths); // Hacky method for find + map

  var routeMatch;
  routeMatchers.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        routePath = _ref2[0],
        regex = _ref2[1],
        groups = _ref2[2];

    var match = path.match(regex);
    if (!match) return null;
    var result = [routePath, {}];

    if (groups && groups.length) {
      result[1] = groups.reduce(function (props, prop, i) {
        props[prop] = match[i + 1];
        return props;
      }, {});
    }

    return routeMatch = result;
  });
  if (!routeMatch) return null;

  var _routeMatch = routeMatch,
      _routeMatch2 = _slicedToArray(_routeMatch, 2),
      routePath = _routeMatch2[0],
      props = _routeMatch2[1];

  return routes[routePath](props);
}

function createRouteMatcher(routePath) {
  var route = [routePath, new RegExp("".concat(routePath.substr(0, 1) === '*' ? '' : '^').concat(routePath.replace(/:[a-zA-Z]+/g, '([^/]+)').replace(/\*/g, '')).concat(routePath.substr(-1) === '*' ? '' : '$'), 'i')];
  var propList = routePath.match(/:[a-zA-Z]+/g);
  route.push(propList ? propList.map(function (paramName) {
    return paramName.substr(1);
  }) : []);
  return route;
}

function navigate(url) {
  var replaceOrQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof url === 'object') {
    throw new Error('"url" must be a string, was provided an object.');
  }

  if (replaceOrQuery && typeof replaceOrQuery === 'object') {
    url += '?' + new URLSearchParams(replaceOrQuery).toString();
  } else {
    replace = replaceOrQuery;
  }

  window.history["".concat(replace ? 'replace' : 'push', "State")](null, null, url);
  dispatchEvent(new PopStateEvent('popstate', null));
}

function useRedirect(predicateUrl, targetUrl) {
  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var replace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var currentPath = usePath();

  if (currentPath === predicateUrl) {
    navigate(targetUrl, queryParams, replace);
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Link(props) {
  var _useRouter = useRouter(),
      basePath = _useRouter.basePath;

  var href = props.href.substr(0, 1) === '/' ? basePath + props.href : props.href;
  var onClick = useCallback(function (e) {
    try {
      if (props.onClick) props.onClick(e);
    } catch (ex) {
      e.preventDefault();
      throw ex;
    }

    if (shouldTrap(e)) {
      e.preventDefault(); // prevent the link from actually navigating

      navigate(e.currentTarget.href);
    }
  }, [basePath, href]);
  return React.createElement("a", _extends({}, props, {
    href: href,
    onClick: onClick
  }));
}

function shouldTrap(e) {
  return !e.defaultPrevented && // onClick prevented default
  e.button === 0 && // ignore everything but left clicks
  !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function useQueryParams() {
  var parseFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parseQuery;
  var serializeFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : serializeQuery;

  var _useState5 = useState(getQueryString()),
      _useState6 = _slicedToArray(_useState5, 2),
      querystring = _useState6[0],
      setQuerystring = _useState6[1];

  var setQueryParams = useCallback(function (params) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    params = replace ? params : _objectSpread(_objectSpread({}, parseFn(querystring)), params);
    navigate("".concat(getCurrentPath(), "?").concat(serializeFn(params)));
  }, [querystring]); // Watch for location changes

  usePopState('', isNode, function () {
    return setQuerystring(getQueryString());
  });
  return [parseFn(querystring), setQueryParams];
}

function parseQuery(querystring) {
  return _toConsumableArray(new URLSearchParams(querystring)).reduce(function (result, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    result[key] = decodeURIComponent(value);
    return result;
  }, {});
}

function serializeQuery(queryParams) {
  return Object.entries(queryParams).reduce(function (query, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    query.append(key, value);
    return query;
  }, new URLSearchParams());
}

function getQueryString() {
  if (isNode) {
    var _ssrPath = getSsrPath();

    var queryIndex = _ssrPath.indexOf('?');

    return queryIndex === -1 ? '' : _ssrPath.substring(queryIndex + 1);
  }

  return location.search;
}

export { Link, navigate, usePath, usePopState, useQueryParams, useRedirect, useRoutes };